import React from "react";
/* import FancyPDF from "../Documents/components/NSRS/FancyLayout"; */
import SimplePDF from "../Documents/components/NSRS/SimpleLayout";
/* import ModernPDF from "../Documents/components/NSRS/ModernLayout"; */

export default function Test() {
  return <SimplePDF />;
}
